<template>
  <div>
    <!-- FBA操作选择 -->
    <el-dialog :title="$t('message.fBAOperationSelect')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="400px" center>
      <div class="allot">
        <el-select v-model="fba_user" filterable placeholder="FBA">
          <el-option v-for="item in userList" :key="item.id" :label="item.realname" :value="item.id">
          </el-option>
        </el-select>
      </div>


      <span slot="footer" class="dialog-footer">

        <el-button type="primary" @click="setFbaUser">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    porder_sn: { type: Array }
  },
  data() {
    return {
      dialogVisible: false,
      fba_user: '',
      userList: []
    };
  },
  created() {
    this.fbaUserList()
  },
  methods: {
    //下属人员列表
    fbaUserList() {
      this.$api.porderApi.fbaUserList().then(res => {
        this.userList = res.data
      })
    },
    // 分配fba人员
    setFbaUser() {
      let datas = {
        fba_user: this.fba_user,
        porder_sn: this.porder_sn,
      }
      this.$api.porderApi.setFbaUser(datas).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.$parent.fbaList()
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.allot {
  text-align: center;
}
</style>